import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { ORDER_TAG, checkIsArchiveSale } from "@utils/archive-sale";

import { cart } from "./cart";
import { eventSession } from "./eventSession";
import { layout } from "./layout";
import { meta } from "./meta";
import { user } from "./user";

const persistConfig = {
  // key: checkIsArchiveSale() ? `TUNE_${ORDER_TAG}` : "root",
  key: checkIsArchiveSale() ? "tune-archive-sale" : "root",
  storage,
  blacklist: ["layout", "meta"],
};

export const rootReducer = combineReducers({ user, layout, cart, meta, eventSession });

export type TRootState = ReturnType<typeof rootReducer>;

export const persistedReducer = persistReducer<TRootState>(persistConfig, rootReducer as any);
